export default __webpack_public_path__ + "static/media/carousel-icon.2c6bd709.svg";